import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import {compose} from 'recompose';
import {withFirebase} from '../Firebase';
import * as ROUTES from '../../constants/routes';
import {AuthUserContext} from '../Session';
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

const SignInPage = () => (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 to-primary-100 flex items-center justify-center p-4">
        <AuthUserContext.Consumer>
            {authUser =>
                authUser ? <SignInAuth/> : <SignInNonAuth/>
            }
        </AuthUserContext.Consumer>
    </div>
);

const INITIAL_STATE = {
    email: '',
    password: '',
    error: null,
    showPinModal: false,
    pin: '',
    resolver: null,
    verificationId: null
};

class SignInAuthFormBase extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.history.push(ROUTES.DASHBOARD);
    }

    render() {
        return null;
    }
}

class SignInFormBase extends Component {

    constructor(props) {
        super(props);
        this.state = {...INITIAL_STATE};
        this.verifier = null;
    }

    componentDidMount() {
        this.verifier = this.props.firebase.recaptchaVerifier("sign-in-button");
    }

    onErrorSignIn = (error) => {
        let resolver;
        const selectedIndex = 0;
        if (error.code == 'auth/multi-factor-auth-required') {
            resolver = error.resolver;
            if (resolver.hints[selectedIndex].factorId === "phone") {
                const phoneInfoOptions = {
                    multiFactorHint: resolver.hints[selectedIndex],
                    session: resolver.session
                };
                this.props.firebase
                    .doSignInWithSMS(phoneInfoOptions, this.verifier, resolver)
                    .then((verificationId) => {
                        console.log("verify code sent ", verificationId, " resolver ", resolver)
                        this.setState({
                            verificationId: verificationId,
                            resolver: resolver,
                            showPinModal: true
                        });
                    })
                    .catch(error => {
                        console.error(error);
                        this.setState({error});
                    });
            } else {
                this.setState({error});
            }
        } else if (error.code == 'auth/wrong-password') {
            this.setState({error});
        }
    }

    onSubmit = event => {
        const {email, password} = this.state;
        this.props.firebase
            .doSignInWithEmailAndPassword(email, password)
            .then((userCredential) => {
                const user = userCredential.user;
                this.setState({...INITIAL_STATE});
            }).catch(error => {
            this.onErrorSignIn(error)
        });
        event.preventDefault();
    };

    onChange = event => {
        this.setState({[event.target.name]: event.target.value});
    };

    handleClose = () => {
        this.setState({showPinModal: false});
    }

    handlePinEnter = () => {
        this.setState({showPinModal: false});
        const {pin, verificationId, resolver} = this.state;
        this.props.firebase.doEnterPhoneSMSCode(verificationId, pin, resolver)
    }

    render() {
        const {email, password, showPinModal, pin, error} = this.state;
        const isInvalid = password === '' || email === '';

        return (
            <div className="w-full max-w-md">
                {/* PIN Modal */}
                <Modal show={showPinModal} onHide={this.handleClose} centered>
                    <Modal.Header closeButton className="border-b border-gray-200">
                        <Modal.Title className="text-lg font-semibold text-gray-900">
                            Two-Factor Authentication
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="p-6">
                        <p className="text-gray-600 mb-4">
                            Enter the PIN sent to your phone via SMS.
                        </p>
                        <input
                            name="pin"
                            value={pin}
                            onChange={this.onChange}
                            type="password"
                            placeholder="Enter PIN"
                            className="input"
                            autoFocus
                        />
                    </Modal.Body>
                    <Modal.Footer className="border-t border-gray-200 bg-gray-50">
                        <Button variant="secondary" onClick={this.handleClose}>
                            Cancel
                        </Button>
                        <Button variant="primary" onClick={this.handlePinEnter}>
                            Verify
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Sign In Card */}
                <div className="card shadow-lg">
                    {/* Logo / Header */}
                    <div className="text-center mb-8">
                        <div className="inline-flex items-center justify-center w-16 h-16 bg-primary-100 rounded-full mb-4">
                            <svg className="w-8 h-8 text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                            </svg>
                        </div>
                        <h1 className="text-2xl font-bold text-gray-900 mb-2">
                            Welcome Back
                        </h1>
                        <p className="text-gray-600">
                            Sign in to your Digitalna Kartica account
                        </p>
                    </div>

                    {/* Form */}
                    <form onSubmit={this.onSubmit} className="space-y-5">
                        <div>
                            <label htmlFor="email" className="label">
                                Email Address
                            </label>
                            <input
                                id="email"
                                name="email"
                                value={email}
                                onChange={this.onChange}
                                type="email"
                                placeholder="name@company.com"
                                className="input"
                                autoComplete="email"
                            />
                        </div>

                        <div>
                            <label htmlFor="password" className="label">
                                Password
                            </label>
                            <input
                                id="password"
                                name="password"
                                value={password}
                                onChange={this.onChange}
                                type="password"
                                placeholder="Enter your password"
                                className="input"
                                autoComplete="current-password"
                            />
                        </div>

                        {error && (
                            <div className="bg-danger-50 border border-danger-200 rounded-lg p-3">
                                <p className="text-danger-700 text-sm flex items-center gap-2">
                                    <svg className="w-5 h-5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                                    </svg>
                                    {error.message}
                                </p>
                            </div>
                        )}

                        <button
                            disabled={isInvalid}
                            type="submit"
                            id="sign-in-button"
                            className={`w-full btn btn-primary py-3 text-base ${
                                isInvalid ? 'opacity-50 cursor-not-allowed' : ''
                            }`}
                        >
                            Sign In
                        </button>
                    </form>
                </div>

                {/* Footer */}
                <p className="text-center text-gray-500 text-sm mt-6">
                    Digitalna Kartica - Loyalty Card Management
                </p>
            </div>
        );
    }
}

const SignInNonAuth = () => (
    <SignInForm/>
);

const SignInAuth = () => (
    <SignInAuthForm/>
);

const SignInAuthForm = compose(
    withRouter,
)(SignInAuthFormBase);

const SignInForm = compose(
    withFirebase,
)(SignInFormBase);

export default SignInPage;
export {SignInForm, SignInAuthForm};
